import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "w100 pad40",
  style: {"height":"380px"}
}
const _hoisted_2 = { class: "title mc" }
const _hoisted_3 = {
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "",
  style: {}
}
const _hoisted_6 = { class: "fs14 fw600 mt10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, " メッセージを追加した場合、メールを送信します。メッセージがない場合、お相手に通知は行かず、チャット等で開始した旨をお伝えください。 ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, "テンプレを利用", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_16 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_17 = { class: "fs14 fw400" }
const _hoisted_18 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_19 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_ModalTemplates = _resolveComponent("ModalTemplates")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "AlertWithTextareaModal",
    "content-class": "modalContent shadowContent rad10 modalStandard posFi"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.text), 1)
        ]),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("label", {
          class: _normalizeClass(`circle_button fw600 fl centered fs12 blueAround`),
          style: {"width":"120px","padding":"4px 10px","margin-bottom":"5px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.useTemplate && _ctx.useTemplate(...args)))
        }, _hoisted_11),
        _hoisted_12,
        _createVNode(_component_TextareaTag, {
          placeholder: "ご利用いただきましてありがとうございます。",
          style: {"height":"100px"},
          class: "fs14 roundForm mw100",
          value: _ctx.typedMessage,
          onInputValue: _ctx.inputMessage
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_13,
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("section", {
            class: "llgreyBg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
          }, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.cancelButtonName ? _ctx.cancelButtonName : `キャンセル`), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickOK && _ctx.clickOK(...args)))
          }, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.okButtonName ? _ctx.okButtonName : `決定`), 1)
          ])
        ])
      ]),
      _createVNode(_component_ModalTemplates, {
        members: _ctx.room ? _ctx.room.members : null,
        appo: _ctx.room ? _ctx.room.current_appointment : null,
        onDecideTemplate: _ctx.decideTemplate
      }, null, 8, ["members", "appo", "onDecideTemplate"])
    ]),
    _: 1
  }))
}